<div class="mat-dialog-title" fxLayout="row" fxLayoutAlign="space-between center">
  <p>Adicionar em Lote</p>
  <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
</div>

<mat-tab-group [selectedIndex]="getSelectedTabIndex()" (selectedTabChange)="changeTab($event)">
  <mat-tab label="ADICIONAR">
    <div class="file-upload">
      <div class="file-header">
        <p class="txt">Adicionar vários produtos de uma vez.</p>
        <a [href]="fileLink" download>
          <mat-icon aria-hidden="false">file_download</mat-icon>
          <p class="txt">Download do arquivo modelo .csv</p>
        </a>
      </div>
      <div class="file-input">
        <form (ngSubmit)="uploadFile()">
          <label for="file" *ngIf="!fileName">Clique aqui para selecionar o arquivo .CSV</label>
          <label for="file" *ngIf="fileName">{{ fileName }}</label>
          <input type="file" accept=".csv" id="file" files (change)="getFile($event)" />
          <button class="btn"><mat-icon aria-hidden="false">add_box</mat-icon>ADICIONAR PRODUTOS EM LOTE</button>
        </form>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="RESULTADO">
    <div class="results" fxLayout="column" fxLayoutAlign="center center">
      <h1 class="title" *ngIf="hasExportKey()">Processado</h1>
      <h1 class="title" *ngIf="!hasExportKey()">Processando</h1>
      <button mat-flat-button [class]="!hasExportKey() ? 'report-btn-off' : 'report-btn'" (click)="exportFile()">Baixar relatório</button>
      <div class="message" *ngIf="hasExportKey()">
        <mat-icon aria-hidden="false">check</mat-icon>
        <span>Relatório dísponivel para download</span>
      </div>
      <div class="message" *ngIf="!hasExportKey()">
        <mat-icon aria-hidden="false">close</mat-icon>
        <span>Relatório indisponivel para download</span>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
